import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { CashierSuccessView } from '../shared/CashierSuccessView'

export interface StampCorrectionResult {
  stampsRemoved: number
  memberFullName: string
  memberFirstName: string
  newTotal: number
  stampTarget: number
}

interface StampCorrectionSuccessViewProps {
  result: StampCorrectionResult
  onScanNext: () => void
  onDone: () => void
}

export function StampCorrectionSuccessView({ result, onScanNext, onDone }: StampCorrectionSuccessViewProps) {
  const { t } = useTranslation()
  const { stampsRemoved, memberFullName, memberFirstName, newTotal, stampTarget } = result

  const stampsLabel = stampsRemoved === 1
    ? t('stampCorrection.success.stampsSingle', { fullName: memberFullName })
    : t('stampCorrection.success.stamps', { count: stampsRemoved, fullName: memberFullName })

  return (
    <CashierSuccessView
      title={t('stampCorrection.success.title')}
      scanNextLabel={t('stampCorrection.success.scanNext')}
      doneLabel={t('stampCorrection.success.done')}
      onScanNext={onScanNext}
      onDone={onDone}
    >
      <Text className="text-base lg:text-lg text-secondary text-center">
        {stampsLabel}
      </Text>

      <Text className="text-base lg:text-lg text-secondary text-center">
        {t('stampCorrection.success.newTotalPrefix', { firstName: memberFirstName })}{' '}
        <Text className="font-bold text-accent">{newTotal} / {stampTarget}</Text>
        {' '}{t('stampCorrection.success.newTotalSuffix')}
      </Text>
    </CashierSuccessView>
  )
}